import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  CardFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// Actions
import { vehicleList, vehicleFilter } from "store/vehicles/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";

const VehicleList = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(vehicleList());
  }, []);

  const [search, setSearch] = useState("");

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(vehicleFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(vehicleFilter(`?search=`));
    setSearch("");
  };

  const params = {
    count: props.vehicles.count,
    next: props.vehicles.next,
    previous: props.vehicles.previous,
    results: props.vehicles.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Vehículos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Vehículos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light mb-1"
                        to="/vehicles/create"
                      >
                        Agregar
                      </Link>
                    </Col>
                    <Col md={5}>
                      <Form className="search-box" onSubmit={onSubmit}>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Placa, conductor..."
                            value={search}
                            onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetSearch}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    {/* <h2 className="mb-3 ps-5 font-size-20">Lista de vehículos</h2> */}
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Placa</th>
                            <th>Conductor</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((vehiculo, idx) => (
                            <tr key={idx}>
                              <th scope="row">{vehiculo.id}</th>
                              <td>{vehiculo.plate}</td>
                              <td>{vehiculo.driver}</td>
                              <td>
                                <Link to={`/vehicles/update/${vehiculo.id}`}>
                                  <span className="bx bx-edit fa-lg align-middle"></span>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="vehicles/"
                      filterFunction={vehicleFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, vehicles } = state.Vehicle;
  return { error, loading, vehicles };
};

export default withRouter(connect(mapStateToProps)(VehicleList));
